export default "__VITE_ASSET__CXLQgvW1__"